<template>
  <div class="basketpage page">
    <div class="columns">
      <div class="column">
        <div class="breadcrumb">
          <router-link to="/">KK</router-link> - <router-link :to="{ name: 'FavoritesPage' }">Favoriten</router-link>
          <h1>Favoriten</h1>
        </div>
      </div>      
    </div>

    <div class="columns">

      <div class="column" v-for="(product, i) in user.fav" :key="i" :sync="user.fav">
        <div class="favourite-product-link">
           <router-link  :to="{ name: 'DetailPage', params: { pg: product.pg, artnr: product.artnr } }">
                <div class="prod-img-container">
                  <img v-if="product.bild != '' && ImageExist( '/upload/product-images/' + product.bild ) " :src=" '/upload/product-images/' + product.bild ">
                  <img class="placholder" v-else :src=" product.bio == 'J' ? '/upload/product-images/platzhalter_bio_bw.png':'/upload/product-images/platzhalter_artikelohnefoto.svg' ">
                </div>
            <div class="p-name p-detail">{{product.bez1}} <span v-if="product.vari">{{product.vari}}</span></div>
            </router-link>
            <div class="p-vpe p-detail">{{product.fmng}} {{product.me}} {{ product.vpe != "lose" ? product.vpe : '' }}</div>
            <div class="p-remove p-detail"><i class="icon icon-remove" v-on:click="removeFromFavorites(i)"></i></div>
        </div>
      </div>

    </div>
    
  </div>
</template>
<script>
export default {
    name: 'Detail',
    props: {
      items: {
        type: Array,
        required: false,
        default: () => [],
      }
    },
    data: function(){
      return {
         cartproducts: []
         }
    },
    created: function(){},
    mounted: function(){},
    computed: {    
        user () {
            return this.$store.state.authentication.user
        },
    },
    methods: {
      ImageExist(url) {
           var img = new Image();
           img.src = url;
           //console.log(img.width);
           return true //img.width > 0;
        },
      removeFromFavorites(i) {
       this.user.fav.splice(i,1)
       this.updateFavOnServer()
     },
     
     updateFavOnServer(){
        const fav = this.user.fav;
        const { dispatch } = this.$store;
        dispatch('fav/update', { fav });
        // use: this.updateFavOnServer()
     },
     
 
    }
}
</script>
<style>
  .favourite-product-link { display: flex; align-items: center; width: 100%; flex-wrap: wrap;  }
  .favourite-product-link a { width: 50%; max-width: 20em; display: flex; align-items: center; text-decoration: none !important; border: 0 solid green; }
  .favourite-product-link:before { display: none; }
  .favourite-product-link .prod-img-container { width: 6em; }
  .favourite-product-link .p-detail { padding: 0.9333333em;  color: #00853e; border: 0 solid red; }
  .favourite-product-link .p-detail.p-name { font-weight: bold; width: 13em; min-width: 10em;  }
  .favourite-product-link .p-detail.p-vpe {  width: 10em; min-width: 10em;  }
  .favourite-product-link .p-detail.p-name span { font-weight: normal; display: block;  }
  .favourite-product-link .p-detail.p-count { font-weight: bold; color: #dc1200; display: flex;  }
  .favourite-product-link .p-detail.p-notes { width: 30%; min-width: 18em; }
  .favourite-product-link .p-detail.p-notes textarea { width: 100%; border: 1px solid #ddd; border-radius: 3px; padding: 0.43333333em; outline: 0 !important; transition: border-color 0.2s ease-in-out; }
  .favourite-product-link .p-detail.p-notes textarea:focus { border: 1px solid #00853e; }
  .favourite-product-link input[type="number"] { width: 3em; text-align: right; margin: 0 0.2333333em }
  .favourite-product-link .p-detail.p-remove { width: 3em; }
  
</style>